import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IBet, ICommentAll, IPaginationFetch } from '../types';
import { RestBids } from '../services/rest_bids';
import {UserRequest} from "../services/rest_users";


interface IBidsState {
  dataBids: Array<IBet>;
  dataAllBids: Array<IBet>;
  totalBids: 0;
  dataCommentAll: Array<ICommentAll>;
  totalComment: 0;
  breadcrumb: [];
  current: '1';
  allDepartment: [],
}

const initialState: IBidsState = {
  dataBids: [],
  dataAllBids: [],
  totalBids: 0,
  dataCommentAll: [],
  totalComment: 0,
  breadcrumb: [],
  current: '1',
  allDepartment: []
}

export const exit: any = createAsyncThunk(
    'exit',
    async () => {
        return await RestBids.exit();
    },
);


export const setBet: any = createAsyncThunk(
  'setBet',
  async (payload: IBet) => {
    return await RestBids.setBet(payload)
  }
)
export const getAllBids: any = createAsyncThunk(
  'getAllBids',
  async (payload: IPaginationFetch) => {
    return await RestBids.getAllBids(payload)
  }
)
export const ping: any = createAsyncThunk(
    'ping',
    async () => {
        return await RestBids.ping()
    }
)
export const updateBet: any = createAsyncThunk(
  'updateBet',
  async (payload: IBet) => {
    return await RestBids.updateBet(payload)
  }
)
export const setIsArchive: any = createAsyncThunk(
  'updateBet',
  async (payload: IBet) => {
    return await RestBids.setIsArchive(payload)
  }
)
export const getAllBidsArchive: any = createAsyncThunk(
  'getAllBidsArchive',
  async (payload: IPaginationFetch) => {
    return await RestBids.getAllBidsArchive(payload)
  }
)
export const searchBits: any = createAsyncThunk(
  'searchBits',
  async (payload: IPaginationFetch) => {
    return await RestBids.searchBits(payload)
  }
)
export const commentAll: any = createAsyncThunk(
  'commentAll',
  async (payload: ICommentAll) => {
    return await RestBids.commentAll(payload)
  }
)
export const commentDelete: any = createAsyncThunk(
  'commentDelete',
  async (payload: ICommentAll) => {
    return await RestBids.commentDelete(payload)
  }
)
export const getAllBidsExcel: any = createAsyncThunk(
  'getAllBidsExcel',
  async (payload: {}) => {
    return await RestBids.getAllBidsExcel(payload)
  }
)
export const updateAllDepartment: any = createAsyncThunk(
  'getAllBidsExcel',
  async (payload: {}) => {
    return await RestBids.updateAllDepartment(payload)
  }
)
export const getCity: any = createAsyncThunk(
  'getCity',
  async (payload: {locale: string}) => {
    return await RestBids.getCity(payload)
  }
)
export const deleteCity: any = createAsyncThunk(
  'deleteCity',
  async (payload: {id: string, locale: string}) => {
    return await RestBids.deleteCity(payload)
  }
)
export const updateCity: any = createAsyncThunk(
  'updateCity',
  async (payload: {id: string, text: string, old: string, locale: string}) => {
    return await RestBids.updateCity(payload)
  }
)
export const getCountry: any = createAsyncThunk(
  'getCountry',
  async (payload: {locale: string}) => {
    return await RestBids.getCountry(payload)
  }
)
export const updateCountry: any = createAsyncThunk(
  'updateCountry',
  async (payload: {id: string, text: string, old: string}) => {
    return await RestBids.updateCountry(payload)
  }
)
export const searchCountry: any = createAsyncThunk(
  'searchCountry',
  async (payload: {value: string, locale: string}) => {
    return await RestBids.searchCountry(payload)
  }
)
export const searchCity: any = createAsyncThunk(
  'searchCity',
  async (payload: {value: string, locale: string}) => {
    return await RestBids.searchCity(payload)
  }
)
export const searchLocation: any = createAsyncThunk(
  'searchLocation',
  async (payload: {value: string, locale: string}) => {
    return await RestBids.searchLocation(payload)
  }
)
export const massiveUpdateCountry: any = createAsyncThunk(
  'massiveUpdateCountry',
  async (payload: []) => {
    return await RestBids.massiveUpdateCountry(payload)
  }
)
export const massiveUpdateCity: any = createAsyncThunk(
  'massiveUpdateCity',
  async (payload: []) => {
    return await RestBids.massiveUpdateCity(payload)
  }
)
export const createCity: any = createAsyncThunk(
  'createCity',
  async (payload: { data: [], locale: string }) => {
    return await RestBids.createCity(payload)
  }
)
const bidsSlice = createSlice({
  name: 'bids',
  initialState,
  reducers: {
    setCommentReducers(state, action) {
      state.totalComment = action.payload.count
      state.dataCommentAll = action.payload.rows
    },
    deleteCommentReducers: function(state, action) {
      state.dataCommentAll = state.dataCommentAll.filter((comment) => comment.id !== action.payload.id);
    },
    clearCommentReducers: function(state) {
      state.dataCommentAll = []
    },
    setBreadcrumb: function(state,action) {
      state.breadcrumb = action.payload
    },
    setCurrentState: function(state,action) {
      state.current = action.payload
    },
    getAllDepartment: function(state,action) {
      state.allDepartment = action.payload
    },
  },
  extraReducers: (builder) => {

  }
})
export default bidsSlice.reducer;
export const {setCommentReducers,deleteCommentReducers,
  clearCommentReducers,setBreadcrumb,setCurrentState} = bidsSlice.actions
